import React, { useState } from 'react';
import { usePWAInstall } from '../../hooks/usePWAInstall';
import { Download, X, Smartphone } from 'lucide-react';

export const InstallPrompt: React.FC = () => {
  const { isInstallable, isInstalled, installApp } = usePWAInstall();
  const [dismissed, setDismissed] = useState(false);

  if (!isInstallable || isInstalled || dismissed) {
    return null;
  }

  const handleInstall = async () => {
    const success = await installApp();
    if (!success) {
      setDismissed(true);
    }
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-50">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4">
        <div className="flex items-start space-x-3">
          <div className="p-2 rounded-lg flex-shrink-0">
            <img src="/icons/GGGBadgeFINAL-01.svg" alt="GGG Logo" className="w-4 h-4 object-contain" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-medium text-gray-900 mb-1">
              Install GGG App
            </h3>
            <p className="text-xs text-gray-600 mb-3">
              Get quick access to your wellness tools. Works offline!
            </p>
            <div className="flex space-x-2">
              <button
                onClick={handleInstall}
                className="flex items-center px-3 py-1.5 bg-red-600 text-white text-xs font-medium rounded hover:bg-red-700 transition-colors"
              >
                <Download className="w-3 h-3 mr-1" />
                Install
              </button>
              <button
                onClick={() => setDismissed(true)}
                className="px-3 py-1.5 text-xs text-gray-500 hover:text-gray-700"
              >
                Not now
              </button>
            </div>
          </div>
          <button
            onClick={() => setDismissed(true)}
            className="text-gray-400 hover:text-gray-600 flex-shrink-0"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

